import { Resource } from "@common/types/auditLog";

export interface ReconciliationMetadata {
    accountName: string | null;
    openingDate: string | null;
    closingDate: string | null;
    openingBalance: number | null;
    closingBalance: number | null;
}

export function extractReconciliationMetadata(
    resources: Resource[] | undefined,
): ReconciliationMetadata | null {
    if (!resources || resources.length === 0) {
        return null;
    }

    const sortedResources = resources.toSorted(
        (a, b) =>
            new Date(a.openingDate).getTime() -
            new Date(b.openingDate).getTime(),
    );

    const earliestResource = sortedResources[0];

    const latestResource = sortedResources[sortedResources.length - 1];

    return {
        accountName:
            earliestResource.financialAccount?.name ??
            earliestResource.financialAccountName ??
            null,
        openingDate: earliestResource.openingDate ?? null,
        closingDate: latestResource.closingDate ?? null,
        openingBalance: earliestResource.openingBalance ?? null,
        closingBalance: latestResource.closingBalance ?? null,
    };
}
